<template>
  <WidgetWrapper
    lg="6"
    :title="$t('delivery.dashboard.TopVendorRejectedDelivery', { count: dataShown })"
    :tooltip-text="$t('delivery.dashboard.TopVendorRejectedDeliveryTooltip')"
  >
    <template #afterTitle>
      <div class="d-flex gap-3 flex-wrap vendor-filter">
        <b-form-radio-group
          id="btn-radios-1"
          v-model="selected"
          :options="radioGroupOptions"
          name="radios-btn-default"
          buttons
          button-variant="outline-primary"
        ></b-form-radio-group>
      </div>
    </template>
    <b-dropdown
      id="actions-dropdown"
      toggle-tag="div"
      toggle-class="p-0 bg-transparent"
      class="w-auto mb-4"
    >
      <template #button-content>
        <McButton
          variant="secondary"
          icon="icon-outline_chevron-down"
          icon-position="right"
          :text="$t('delivery.dashboard.topData', { count: dataShown })"
        />
      </template>

      <b-dropdown-item
        class="mc-dashboard__order-dropdown"
        v-for="limit in dataLimits"
        :key="limit"
        @click="handleChangeDataShown(limit)"
        :class="{ 'font-weight-bold': limit === dataShown }"
      >
        {{ limit }}
      </b-dropdown-item
      >
    </b-dropdown>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-skeleton-img no-aspect height="400px" />
      </template>
      <b-table
        v-if="selected === 'tabel'"
        sticky-header="400px"
        small
        show-empty
        :fields="fields"
        :items="orderList"
        responsive
        empty-table
        :empty-text="$t('global.emptyTable')"
      />
      <HorizontalBarChart v-else :options="chartOptions" :labels="labels" :datasets="datasets" />
    </b-skeleton-wrapper>
  </WidgetWrapper>
</template>

<script>
import WidgetWrapper from './WidgetWrapper.vue'
import McButton from '@/components/McButton'
import HorizontalBarChart from '@/components/Chart/HorizontalBar'
import topVendorRejectedDelivery from '../lib/fields/topVendorRejectedDelivery'
import { getTopVendorRejectedDelivery } from '@/services/rest-api/lib/dashboard/delivery-widget'

export default {
  components: {
    WidgetWrapper,
    McButton,
    HorizontalBarChart,
  },
  data() {
    return {
      period: [],
      selected: 'tabel',
      dataShown: 5,
      loading: false,
      orderList: [],
    }
  },
  computed: {
    fields() {
      return topVendorRejectedDelivery()
    },
    datasets() {
      return [
        {
          data: this.orderList.map((order) => order.delivery_order_count),
          label: this.$t('delivery.fields.totalRejectionOfDelivery'),
          backgroundColor: '#1C74DA',
        },
      ]
    },
    labels() {
      return this.orderList.map((order) => order.vendor.name)
    },
    dataLimits() {
      return [5, 10, 20]
    },
    apiClient() {
      return { get: getTopVendorRejectedDelivery }
    },
    chartOptions() {
      return {
        legend: { position: 'bottom', labels: { boxWidth: 0 } },
        scales: {
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
                callback: (value) => {
                  if (Number.isInteger(value)) {
                    return value
                  }
                },
              },
            },
          ],
        },
      }
    },
    radioGroupOptions() {
      return [
        {
          html: `<i class="icon-outline_browser"></i><span>${this.$t(
            'delivery.text.table'
          )}</span>`,
          value: 'tabel',
        },
        {
          html: `<i class="icon-outline_bar-chart-2"></i><span>${this.$t(
            'delivery.text.chart'
          )}</span>`,
          value: 'grafik',
        },
      ]
    }
  },
  mounted() {
    this.handleFetchVendorRejected()
  },
  methods: {
    handleChangeDataShown(count) {
      this.dataShown = count
      this.handleFetchVendorRejected()
    },
    async handleFetchVendorRejected() {
      this.loading = true

      const params = { limit: this.dataShown }
      const res = await getTopVendorRejectedDelivery(params)

      if (res.errors) return

      this.orderList = res.data.map((order, idx) => ({ ...order, number: `${idx + 1}.` }))
      this.loading = false
    },
  },
}
</script>

<style scoped lang="scss">
:deep(input[type='radio']) {
  display: none;

  & + span {
    display: flex;

    i {
      margin-right: 4px;
      font-size: 20px;
    }
  }
}

:deep(.mx-datepicker) {
  width: 215px !important;

  @include xs-screen-only {
    width: 100% !important;
  }
}

:deep(.formulate-input) {
  height: auto;
  padding: 0;
}

.vendor-filter {
  margin-left: auto;
  flex-wrap: wrap;
  justify-content: end;
  width: 100%;

  @include xs-screen-only {
    flex-grow: 1;
    justify-content: center;

    & > * {
      width: 100% !important;
    }
  }
}

:deep(#actions-dropdown) {
  & > * {
    width: 150px !important;
  }

  .dropdown-menu {
    min-width: 0;
  }

  button {
    width: 100%;
    justify-content: space-between;
  }
}
</style>
